import App from './Trainer/App.svelte';

const app = new App({
    target: document.body,
});

export default app;
